import React from "react"
import utilStyles from "../../asset/styles/util/util.module.scss"
import detailStyles from "../../asset/styles/excursionDetail/excursionDetail.module.scss"
import Grid from "@mui/material/Grid"
import Table, { TableColumn } from "component/table/table"
import InputText from "component/inputText/inputText"
import { ExcursionDetailModel, ExcursionPricingModel } from "../../models"

interface ExcursionPricingProps {
    excursion: ExcursionDetailModel
    onChange: (updates: Partial<ExcursionDetailModel>) => void
    readOnly?: boolean
    error?: string
}

const capitalize = (s: string) =>
    s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s

const ExcursionPricing: React.FC<ExcursionPricingProps> = ({
    excursion,
    onChange,
    readOnly = false,
    error,
}) => {
    const data = excursion.excursion_pricing || []
    const childPolicy = excursion.child_policy || []
    // const useCompactPricingRows = data.length >= 3
    const isChildFree = childPolicy.some(
        (c) => c.category_name?.toLowerCase() === "child" && c.flag_free_of_charge
    )

    const updateRow = (index: number, updates: Partial<ExcursionPricingModel>) => {
        const updated = data.map((row, i) => (i === index ? { ...row, ...updates } : row))
        onChange({ excursion_pricing: updated })
    }

    const columns: TableColumn<ExcursionPricingModel>[] = [
        {
            key: "category_name",
            label: "Category",
            align: "left",
            width: "50%",
            render: (value: string) => capitalize(value ?? ""),
        },
        {
            key: "base_price",
            label: "Base Price",
            align: "left",
            width: "50%",
            render: (value: number, row: ExcursionPricingModel) => {
                const index = data.findIndex(
                    (r) => r.excursion_pricing_id === row.excursion_pricing_id
                )
                const isChildRow = row.category_name?.toLowerCase() === "child"
                const disabled = isChildRow && isChildFree
                const isEmptyOrInvalid = value == null || !Number.isFinite(value) || value <= 0
                return (
                    <InputText
                        label=""
                        value={(value ?? 0) < 0 ? "" : String(value)}
                        onChange={(e) =>
                            updateRow(index, { base_price: Number(e.target.value) || 0 })
                        }
                        disabled={readOnly || disabled}
                        error={error && isEmptyOrInvalid ? error : undefined}
                    />
                )
            },
        },
    ]

    return (
        <div className={`${utilStyles.pageContainerContent} ${detailStyles.excursionPolicyColumn}`}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <div className={detailStyles.excursionPanelTitleRow}>
                        <b>Pricing</b>
                    </div>
                </Grid>
                {error && (
                    <Grid size={{ xs: 12, md: 12 }}>
                        <span style={{ color: "#d32f2f", fontSize: 14 }}>{error}</span>
                    </Grid>
                )}
                <Grid size={{ xs: 12, md: 12 }}>
                    <Table
                        minWidth={100}
                        columns={columns}
                        data={data}
                        keyExtractor={(row) => row.excursion_pricing_id}
                        containerClassName={detailStyles.excursionFormTableWrap}
                        // className={useCompactPricingRows ? detailStyles.excursionPricingTableCompact : undefined}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default ExcursionPricing
